<template>
  <div class="qyxxbgDiaLogBody">
    <div class="_title">
      <p class="_title_info">化学品/资质证件变更</p>
    </div>
    <el-table
      ref="cktable"
      :data="
        hxpBgjlDtos.slice((currentPage - 1) * pagesize, currentPage * pagesize)
      "
      border
      :show-overflow-tooltip="true"
      :header-cell-style="{ background: '#F2F2F2' }"
      style="width: 85%; margin: 0px auto; z-index: 0"
    >
      <el-table-column align="center" label="化学品名称">
        <template slot-scope="scope">
          <span>{{ scope.row.hxpmc.afterValue }}</span>
          <el-popover
            v-show="scope.row.hxpmc.isChange"
            style="margin-left: 5px"
            placement="top-start"
            width="200"
            trigger="hover"
            :content="
              '修改前内容:' +
                (scope.row.hxpmc.beforeValue == null
                  ? '无'
                  : scope.row.hxpmc.beforeValue)
            "
          >
            <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column align="center" label="业务类型">
        <template slot-scope="scope">
          <span>{{ scope.row.ywlxLabel.afterValue }}</span>
          <el-popover
            v-show="scope.row.ywlxLabel.isChange"
            style="margin-left: 5px"
            placement="top-start"
            width="200"
            trigger="hover"
            :content="
              '修改前内容:' +
                (scope.row.ywlxLabel.beforeValue == null
                  ? '无'
                  : scope.row.ywlxLabel.beforeValue)
            "
          >
            <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column align="center" label="年涉及数量">
        <template slot-scope="scope">
          <span>{{ scope.row.nsjsl.afterValue }}</span>
          <el-popover
            v-show="scope.row.nsjsl.isChange"
            style="margin-left: 5px"
            placement="top-start"
            width="200"
            trigger="hover"
            :content="
              '修改前内容:' +
                (scope.row.nsjsl.beforeValue == null
                  ? '无'
                  : scope.row.nsjsl.beforeValue)
            "
          >
            <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column align="center" label="年涉及数量单位">
        <template slot-scope="scope">
          <span>{{ scope.row.nsjslDwLabel.afterValue }}</span>
          <el-popover
            v-show="scope.row.nsjslDwLabel.isChange"
            style="margin-left: 5px"
            placement="top-start"
            width="200"
            trigger="hover"
            :content="
              '修改前内容:' +
                (scope.row.nsjslDwLabel.beforeValue == null
                  ? '无'
                  : scope.row.nsjslDwLabel.beforeValue)
            "
          >
            <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column align="center" label="用途">
        <template slot-scope="scope">
          <span>{{ scope.row.yt.afterValue }}</span>
          <el-popover
            v-show="scope.row.yt.isChange"
            style="margin-left: 5px"
            placement="top-start"
            width="200"
            trigger="hover"
            :content="
              '修改前内容:' +
                (scope.row.yt.beforeValue == null
                  ? '无'
                  : scope.row.yt.beforeValue)
            "
          >
            <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager,next,jumper,total,sizes"
      :page-sizes="[10, 20, 30, 40]"
      :total="hxpBgjlDtos.length"
      :page-size="pagesize"
      class="el-page"
      :current-page.sync="currentPage"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <div class="_jbxxInfo">
      <div class="_jbxxTitle">资质证件</div>
    </div>
    <ul class="uploadzhengjian">
      <li v-for="(item, i) in imgListArray" :key="i" style="margin: 0px 30px">
        <img
          v-preventReClick
          style="margin: auto"
          :src="item.imageurl"
          alt=""
          @click="
            imageClick(item.name.split('<').slice(0, 1).toString(), item.zjlx)
          "
        >
        <p v-preventReClick @click="exportMb" v-html="item.name" />
      </li>
    </ul>
    <div class="_title _title2">
      <p class="_title_info">审批结果</p>
    </div>
    <div style="width: 100%">
      <el-timeline>
        <el-timeline-item
          v-if="sphjDtoList[0]"
          icon="el-icon-time"
          size="large"
        >
          <div style="margin-top: 2px">
            <span style="font-weight: bold"> 申请时间： </span>
            <span>{{ sphjDtoList[0].clsj }}</span>
          </div>
        </el-timeline-item>
        <el-timeline-item
          v-for="(item, index) in sphjDtoList"
          :key="index"
          :icon="index == sphjDtoList.length - 1 ? 'el-icon-success' : ''"
          :type="item.type"
          :size="index == sphjDtoList.length - 1 ? 'large' : item.size"
          :color="item.color"
        >
          <div style="display: flex">
            <div style="margin-right: 20px">
              <span style="font-weight: bold">审批单位：</span>{{ item.dqbmLabel }}
            </div>
            <div v-if="item.sftyLabel !== '待审批'" style="margin-right: 20px">
              <span style="font-weight: bold">{{ item.jsLabel }}人：</span>{{ item.sjsprLabel }}
            </div>
            <div style="margin-right: 20px">
              <span style="font-weight: bold">审批结果：</span><span
                :style="
                  item.sftyLabel == '同意'
                    ? 'color: #00ceb7'
                    : item.sftyLabel == '不同意'
                      ? 'color: red'
                      : 'color: Orange'
                "
              >{{ item.sftyLabel }}</span>
            </div>
            <div v-if="item.sftyLabel !== '待审批'" style="margin-right: 20px">
              <span style="font-weight: bold">审批时间：</span>{{ item.spsj }}
            </div>
          </div>
          <div v-if="item.sftyLabel !== '待审批'" style="margin-top: 2px">
            <span style="font-weight: bold">审批意见：</span><span>{{ item.spyj }}</span>
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>
    <div class="buttonList">
      <el-button v-preventReClick class="zsbc" @click="exit()">退出</el-button>
    </div>
    <!-- 打开许可证弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible.sync="dialogFormVisible1"
      center
      custom-class="zhengjiatable"
    >
      <el-table
        :data="imagetableData"
        border
        style="width: 100%"
        max-height="420"
      >
        <el-table-column
          v-for="(item, i) in headerlist"
          :key="i"
          align="center"
          :prop="item.prop"
          :label="item.label"
        />
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-view"
              size="mini"
              style="background-color: #4170ff"
              @click="handleView(scope.$index, scope.row)"
            >查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 许可证弹窗的弹窗 -->
      <dialog-1
        ref="dialog1"
        :type="type"
        :dialog-form-visible="dialogFormVisible"
        :title="title"
        :zjlx="imagezjlx"
        @close-dialog="closeDialog"
      />
      <!-- 许可证弹窗的弹窗end -->
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          style="
            background-color: #4170ff;
            width: 90px;
            height: 40px;
            margin-bottom: 20px;
          "
          @click="dialogFormVisible1 = false"
        >关闭</el-button>
      </div>
    </el-dialog>
    <!-- 打开许可证弹窗end -->

    <!-- 添加化学品弹窗 -->
    <div>
      <el-dialog
        v-if="dialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        destroy-on-close
        custom-class="waibu"
        center
      >
        <chemicalPupop :content="content" :puptype="puptype" />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import chemicalPupop from '@/components/qyxxbg/qyxxbgHxpPupop'
import dialog1 from '@/components/qyxxbg/qyxxbgLook/qyxxbgLookDia.vue'
import { getkv } from '@/assets/js/common.js'
export default {
  components: {
    chemicalPupop,
    dialog1
  },
  props: { hxpBgjlDtos: [], fjmkInfoDtos: [], sphjDtoList: [] },
  data() {
    return {
      haveDwFjlxZl: '', // 控制图片蓝绿状态
      title: '', // 标题
      dialogFormVisible1: false, // 弹窗开关
      imagetableData: [], // 弹窗表格数据
      headerlist: [], // 字段列表
      type: true,
      dialogFormVisible: false, // 对话框的显示隐藏
      imagezjlx: 0, // 当前img证件类型
      yzd_nsjsl_dw: [], // 年涉及数量单位
      imgListArray: [], // 证件照片列表
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      dialogVisible: false // 弹窗开关
    }
  },
  computed: {},
  watch: {
    hxpBgjlDtos: {
      // 这监听对象值的改变 和上面的不一样。
      handler(curVal, oldVal) {
        this.imageChange()
      },
      deep: true
    },
    fjmkInfoDtos: {
      // 这监听对象值的改变 和上面的不一样。
      handler(curVal, oldVal) {
        this.imagetableData = []
        if (this.fjmkInfoDtos) {
          this.fjmkInfoDtos.forEach((element) => {
            if (
              element.dwfjDtos &&
              element.dwfjDtos[0].zjlx == this.zjlxActive
            ) {
              this.imagetableData.push(element)
            }
          })
        }
      },
      deep: true
    }
  },
  created() {
    // 化学品数量单位
    getkv('yzd_nsjsl_dw').then((e) => {
      this.yzd_nsjsl_dw = e.data.data
    })
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    handleView(index, row) {
      this.dialogFormVisible = true
      this.type = true
      this.$refs.dialog1.csh(row)
    },
    exportMb(e) {
      if (e.target.innerText.toString() == '下载模板') {
        const link = document.createElement('a')
        link.href = process.env.VUE_APP_PUBLIC_PORT + '/hfsyxyzm.doc'
        link.download = '模板'
        link.click()
      }
    },
    closeDialog() {
      // 关闭对话框
      this.dialogFormVisible = false
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
    },
    // 点击图片
    imageClick(name, zjlx) {
      this.title = name
      this.imagezjlx = zjlx
      // 查询许可证附件table信息
      this.getFjTableMess(zjlx)
      this.dialogFormVisible1 = true
    },
    // 根据证件类型获取表格字段
    getFjTableMess(zjlx) {
      this.zjlxActive = zjlx
      this.imagetableData = []
      this.fjmkInfoDtos.forEach((element) => {
        if (element.dwfjSjxxDto.zjlx == zjlx) {
          this.imagetableData.push(element)
        }
      })
      switch (zjlx) {
        case 2: // 非药品类易制毒化学品生产许可证
          this.headerlist = []
          this.headerlist.push(
            { prop: 'dwfjSjxxDto.zjbh.', label: '编号' },
            { prop: 'dwfjSjxxDto.dwmc', label: '单位名称' },
            { prop: 'dwfjSjxxDto.fzr', label: '主要负责人' },
            { prop: 'dwfjSjxxDto.pzcl', label: '生产品种' },
            { prop: 'dwfjSjxxDto.yxqKs', label: '有效期开始' },
            { prop: 'dwfjSjxxDto.yxqJs', label: '有效期结束' },
            { prop: 'dwfjSjxxDto.statusLabel', label: '状态' }
          )
          break
        case 3: // 非药品类易制毒化学品经营许可证
          this.headerlist = []
          this.headerlist.push(
            { prop: 'dwfjSjxxDto.zjbh', label: '编号' },
            { prop: 'dwfjSjxxDto.dwmc', label: '单位名称' },
            { prop: 'dwfjSjxxDto.fzr', label: '主要负责人' },
            { prop: 'dwfjSjxxDto.pzcl', label: '经营品种' },
            { prop: 'dwfjSjxxDto.yxqKs', label: '有效期开始' },
            { prop: 'dwfjSjxxDto.yxqJs', label: '有效期结束' },
            { prop: 'dwfjSjxxDto.statusLabel', label: '状态' }
          )
          break
        case 13: // 非药品类易制毒化学品生产备案证明
          this.headerlist = []
          this.headerlist.push(
            { prop: 'dwfjSjxxDto.zjbh', label: '编号' },
            { prop: 'dwfjSjxxDto.dwmc', label: '单位名称' },
            { prop: 'dwfjSjxxDto.fzr', label: '主要负责人' },
            { prop: 'dwfjSjxxDto.pzlb', label: '生产品种' },
            { prop: 'dwfjSjxxDto.yxqKs', label: '有效期开始' },
            { prop: 'dwfjSjxxDto.yxqJs', label: '有效期结束' },
            { prop: 'dwfjSjxxDto.statusLabel', label: '状态' }
          )
          break
        case 17: // 非药品类易制毒化学品经营备案证明
          this.headerlist = []
          this.headerlist.push(
            { prop: 'dwfjSjxxDto.zjbh', label: '编号' },
            { prop: 'dwfjSjxxDto.dwmc', label: '单位名称' },
            { prop: 'dwfjSjxxDto.fzr', label: '主要负责人' },
            { prop: 'dwfjSjxxDto.pzcl', label: '经营品种' },
            { prop: 'dwfjSjxxDto.yxqKs', label: '有效期开始' },
            { prop: 'dwfjSjxxDto.yxqJs', label: '有效期结束' },
            { prop: 'dwfjSjxxDto.statusLabel', label: '状态' }
          )
          break
        case 6: // 安全生产许可证
          this.headerlist = []
          this.headerlist.push(
            { prop: 'dwfjSjxxDto.zjbh', label: '证件编号' },
            { prop: 'dwfjSjxxDto.dwmc', label: '单位名称' },
            { prop: 'dwfjSjxxDto.fzr', label: '主要负责人' },
            { prop: 'dwfjSjxxDto.jyfw', label: '许可范围' },
            { prop: 'dwfjSjxxDto.yxqKs', label: '有效期开始' },
            { prop: 'dwfjSjxxDto.yxqJs', label: '有效期结束' },
            { prop: 'dwfjSjxxDto.statusLabel', label: '状态' }
          )
          break

        case 22: // 合法使用需要证明
          this.headerlist = []
          this.headerlist.push(
            { prop: 'dwfjSjxxDto.dwmc', label: '单位名称' },
            { prop: 'dwfjSjxxDto.hxpMcs', label: '化学品名称' },
            { prop: 'dwfjSjxxDto.sjl', label: '涉及量' },
            { prop: 'dwfjSjxxDto.fzrq', label: '签订日期' },
            { prop: 'dwfjSjxxDto.statusLabel', label: '状态' }
          )
          break
        case 16: // 危险化学品经营许可
          this.headerlist = []
          this.headerlist.push(
            { prop: 'dwfjSjxxDto.zjbh', label: '证件编号' },
            { prop: 'dwfjSjxxDto.dwmc', label: '单位名称' },
            { prop: 'dwfjSjxxDto.fzr', label: '单位法定代表人' },
            { prop: 'dwfjSjxxDto.jyfw', label: '许可范围' },
            { prop: 'dwfjSjxxDto.yxqKs', label: '有效期开始' },
            { prop: 'dwfjSjxxDto.yxqJs', label: '有效期结束' },
            { prop: 'dwfjSjxxDto.statusLabel', label: '状态' }
          )
          break
        case 12: // 道路运输经营许可
          this.headerlist = []
          this.headerlist.push(
            { prop: 'dwfjSjxxDto.zjbh', label: '证件编号' },
            { prop: 'dwfjSjxxDto.dwmc', label: '业户名称' },
            { prop: 'dwfjSjxxDto.yxqKs', label: '有效期开始' },
            { prop: 'dwfjSjxxDto.yxqJs', label: '有效期结束' },
            { prop: 'dwfjSjxxDto.statusLabel', label: '状态' }
          )
          break
        case 23: // 其他证件
          this.headerlist = []
          this.headerlist.push(
            { prop: 'dwfjSjxxDto.zsmc', label: '证件名称' },
            { prop: 'dwfjSjxxDto.zjbh', label: '证件编号' },
            { prop: 'dwfjSjxxDto.yxqKs', label: '有效期开始' },
            { prop: 'dwfjSjxxDto.yxqJs', label: '有效期结束' },
            { prop: 'dwfjSjxxDto.statusLabel', label: '状态' }
          )
          break
        case 24: // 危险货物道路运输许可证
          this.headerlist = []
          this.headerlist.push(
            { prop: 'dwfjSjxxDto.zjbh', label: '证件编号' },
            { prop: 'dwfjSjxxDto.dwmc', label: '业户名称' },
            { prop: 'dwfjSjxxDto.yxqKs', label: '有效期开始' },
            { prop: 'dwfjSjxxDto.yxqJs', label: '有效期结束' },
            { prop: 'dwfjSjxxDto.fzrq', label: '发证日期' },
            { prop: 'dwfjSjxxDto.statusLabel', label: '状态' }
          )
          break
        default:
          break
      }
    },
    // 许可证变化
    imageChange() {
      if (this.haveDwFjlxZl) {
        var zjlxList = this.haveDwFjlxZl.split(',')
      } else {
        var zjlxList = []
      }
      this.imgListArray = []
      // 生产类必有
      var res1 = this.hxpBgjlDtos.some((item, index, arr) => {
        return item.ywlx.afterValue == '1'
      })
      res1 == true
        ? this.imgListArray.push({
          zjlx: 6,
          name: '安全生产许可证',
          imageurl: zjlxList.includes('6')
            ? require('@/assets/img/step41.png')
            : require('@/assets/img/step41_down.png')
        })
        : ''
      // 生产1类
      var res2 = this.hxpBgjlDtos.some((item, index, arr) => {
        return item.ywlx.afterValue == '1' && item.hxpLb.afterValue == '100'
      })
      res2 == true
        ? this.imgListArray.push({
          zjlx: 2,
          name: '非药品类易制毒化学品生产许可证',
          imageurl: zjlxList.includes('2')
            ? require('@/assets/img/step42.png')
            : require('@/assets/img/step42_down.png')
        })
        : ''
      // 生产2,3类
      var res3 = this.hxpBgjlDtos.some((item, index, arr) => {
        return (
          item.ywlx.afterValue == '1' &&
          (item.hxpLb.afterValue == '200' || item.hxpLb.afterValue == '300')
        )
      })
      res3 == true
        ? this.imgListArray.push({
          zjlx: 13,
          name: '非药品类易制毒化学品生产备案证明',
          imageurl: zjlxList.includes('13')
            ? require('@/assets/img/step43.png')
            : require('@/assets/img/step43_down.png')
        })
        : ''
      var res11 = this.hxpBgjlDtos.some((item, index, arr) => {
        return item.ywlx.afterValue == '3' || item.ywlx.afterValue == '6' // 有一项成员通过就true
      })
      res11 == true
        ? this.imgListArray.push({
          zjlx: 16,
          name: '危险化学品经营许可证',
          imageurl: zjlxList.includes('16')
            ? require('@/assets/img/step47.png')
            : require('@/assets/img/step47_down.png'),
          flag: false
        })
        : ''
      // 经营和使用必有
      var res12 = this.hxpBgjlDtos.some((item, index, arr) => {
        return item.ywlx.afterValue == '3' || item.ywlx.afterValue == '2' // 有一项成员通过就true
      })
      res12 == true
        ? this.imgListArray.push({
          zjlx: 22,
          name: '合法使用需要证明',
          imageurl: zjlxList.includes('22')
            ? require('@/assets/img/step44.png')
            : require('@/assets/img/step44_down.png'),
          flag: false
        })
        : ''
      // 经营1类
      var res4 = this.hxpBgjlDtos.some((item, index, arr) => {
        return item.ywlx.afterValue == '3' && item.hxpLb.afterValue == '100'
      })
      res4 == true
        ? this.imgListArray.push({
          zjlx: 3,
          name: '非药品类易制毒化学品经营许可证',
          imageurl: zjlxList.includes('3')
            ? require('@/assets/img/step46.png')
            : require('@/assets/img/step46_down.png')
        })
        : ''

      // 经营2和3类
      var res5 = this.hxpBgjlDtos.some((item, index, arr) => {
        return (
          item.ywlx.afterValue == '3' &&
          (item.hxpLb.afterValue == '200' || item.hxpLb.afterValue == '300')
        )
      })
      res5 == true
        ? this.imgListArray.push({
          zjlx: 17,
          name: '非药品类易制毒化学品经营备案证明',
          imageurl: zjlxList.includes('17')
            ? require('@/assets/img/step48.png')
            : require('@/assets/img/step48_down.png'),
          flag: true
        })
        : ''
      // 运输类
      var res6 = this.hxpBgjlDtos.some((item, index, arr) => {
        return item.ywlx.afterValue === '4'
      })
      res6 == true
        ? this.imgListArray.push(
          {
            zjlx: 12,
            name: '道路运输经营许可证',
            imageurl: zjlxList.includes('12')
              ? require('@/assets/img/step49.png')
              : require('@/assets/img/step49_down.png')
          },
          {
            zjlx: 24,
            name: '危险货物道路运输许可证',
            imageurl: zjlxList.includes('24')
              ? require('@/assets/img/step410.png')
              : require('@/assets/img/step410_down.png'),
            flag: false
          }
        )
        : ''
      if (this.hxpBgjlDtos.length != 0) {
        // 必有  其他证件
        this.imgListArray.push({
          zjlx: 23,
          name: '其他证件',
          imageurl: zjlxList.includes('23')
            ? require('@/assets/img/step45.png')
            : require('@/assets/img/step45_down.png'),
          flag: false
        })
      }
    },
    // 返回父页面
    exit() {
      this.$bus.emit('qyxxbgLookExit')
    }
  }
}
</script>
<style scoped lang='less'>
.qyxxbgDiaLogBody {
  width: 90%;
  max-width: 1200px;
  margin: 10px auto 0px auto;
  display: flex;
  background-color: #fff;
  flex-direction: column;
  align-items: center;
  position: relative;
  ._title {
    margin-top: 50px;
    ._title_info {
      height: 30px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 30px;
    }
  }
  & > .el-button {
    width: 136px;
    height: 40px;
    font-family: Medium;
    font-size: 13px;
    padding: 0;
  }
  .el-pagination {
    margin-bottom: 44px;
    padding: 10px 0;
    width: 85%;
    border: 1px solid #ebeef5;
    border-top: 0;
  }
  .el-button--warning {
    color: #fff;
    background-color: #ed5e0b;
    border-color: #ed5e0b;
  }
  .el-button--primary {
    color: #fff;
    background-color: #4170ff;
    border-color: #4170ff;
  }
  ._jbxxInfo {
    width: 85%;
    margin-bottom: 30px;
    ._jbxxTitle {
      width: 96px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 22px;
    }
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4170ff !important;
    color: #fff;
  }
  .bgzjList {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    p {
      width: 169px;
      margin: auto;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #636363;
      line-height: 20px;
    }
  }
  .buttonList {
    text-align: center;
    margin: 80px auto 60px auto;
    .el-button {
      color: #ffffff;
      width: 148px;
      height: 60px;
      background: #4170ff;
      border-radius: 5px;
    }
  }
  /deep/.spResult {
    width: 90%;
    max-width: 950px;
    display: flex;
    // justify-content: space-between;
    margin: auto;
    div {
      margin-right: 30px;
    }
    .spjg {
      display: flex;
      align-items: center;
    }
  }
}

.uploadzhengjian {
  width: 85%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-left: 0 !important;
  li {
    width: 26%;
    list-style: none;
    text-align: center;
    img {
      width: 202px;
      height: 138px;
    }
    p {
      text-align: center;
      margin: 10px 0 20px;
      span {
        margin-right: 5px;
      }
    }
  }
}
/deep/.el-timeline-item__icon {
  font-size: 16px !important;
  color: #fff;
  background-color: #ef9a12;
  border-radius: 50%;
}

/deep/.el-icon-success {
  color: #6acd18;
  background-color: #fff;
}
</style>
